import { render, staticRenderFns } from "./uploadpdf.vue?vue&type=template&id=6f1271ca&scoped=true&"
import script from "./uploadpdf.vue?vue&type=script&lang=js&"
export * from "./uploadpdf.vue?vue&type=script&lang=js&"
import style0 from "./uploadpdf.vue?vue&type=style&index=0&id=6f1271ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1271ca",
  null
  
)

export default component.exports